import React, { useState } from 'react';
import { Row, Col, Container, Form, FormControl, Button } from 'react-bootstrap';
//Utils
import { formPost } from '../../../utils/api';
import { eventGA } from '../../../utils/ga';
//Components
import ModalAlert from '../../../components/modal_alert/modal_alert';
//CSS
import './style.css';
//
export default function Contact(props){
    const [fields, setFields] = useState({});
    const [showMessage, setShowMessage] = useState(false);
    //
    //Handlers
    function handleField(event){
        let newFields = fields;
        newFields[event.target.name] = event.target.value;
        setFields(newFields);
    }
    //
    //Handlers
    function handleSubmit(event){
        eventGA('Contact_Form', 'Formulário de contato da Landing Page enviado.');
        formPost('/Contact_Form', fields);
        setShowMessage(true);
        event.preventDefault();
    }
    //
    //Renders
    return(
        <>
        <ModalAlert title="Envio de Contato" message="Mensagem Enviada com Sucesso!" isShow={showMessage} onClick={()=>setShowMessage(false)}/>
        <section id={props.id} className="contact-us pt-5 pb-5">
            <Container>
                <Row>
                    <Col md={5}>
                        <div className="section-heading">
                            <h3>{props.title}</h3>
                            {props.text.split(' \n ').map((item, i)=><p key={i}>{item}</p>)}
                        </div>
                        <div className="footer-address">
                            <h6><strong>Nos Encontre:</strong></h6>
                            <ul className="list-unstyled">
                                {props.contactList.map((item, i)=>
                                    <li key={i}><span>{item}</span></li>
                                )}
                            </ul>
                        </div>
                    </Col>
                    <Col md={7}>
                        <Form onSubmit={handleSubmit} id="contactForm" className="contact-us-form">
                            <h5>Envie uma mensagem:</h5>
                            <Row>
                                <Col sm={6} className="col-12">
                                    <Form.Group>
                                        <FormControl onChange={handleField} type="text" name="name" id="name" placeholder="Seu nome" required/>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} className="col-12">
                                    <Form.Group>
                                        <FormControl onChange={handleField} type="email" name="email" id="email" placeholder="E-mail" required/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={6} className="col-12">
                                    <Form.Group>
                                        <FormControl onChange={handleField} type="tel" name="tel" id="tel" placeholder="Telefone"/>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} className="col-12">
                                    <Form.Group>
                                        <FormControl onChange={handleField} type="text" name="about" id="about" placeholder="Assunto"/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="col-12">
                                    <Form.Group>
                                        <FormControl onChange={handleField} name="message" id="message" rows="7" cols="25" placeholder="Mensagem" as="textarea"/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12} className="mt-3">
                                    <Button type="submit" className="btn solid-btn btn-block" id="btnContactUs">
                                        Enviar
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </section>
        </>
    );
}